'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchLevelsIfNeeded = exports.failureLevels = exports.receiveLevels = exports.requestLevels = exports.invalidateLevels = exports.filterLevels = exports.INVALIDATE_LEVELS = exports.FILTER_LEVELS = exports.FAILURE_LEVELS = exports.RECEIVE_LEVELS = exports.REQUEST_LEVELS = undefined;

var _api = require('../api');

var REQUEST_LEVELS = exports.REQUEST_LEVELS = 'REQUEST_LEVELS'; /**
                                                                 * 客户等级相关Actions
                                                                 */
var RECEIVE_LEVELS = exports.RECEIVE_LEVELS = 'RECEIVE_LEVELS';
var FAILURE_LEVELS = exports.FAILURE_LEVELS = 'FAILURE_LEVELS';
var FILTER_LEVELS = exports.FILTER_LEVELS = 'FILTER_LEVELS';
var INVALIDATE_LEVELS = exports.INVALIDATE_LEVELS = 'INVALIDATE_LEVELS';

var filterLevels = exports.filterLevels = function filterLevels(filter) {
    return {
        type: FILTER_LEVELS,
        filter: filter
    };
};

var invalidateLevels = exports.invalidateLevels = function invalidateLevels(filter) {
    return {
        type: INVALIDATE_LEVELS,
        filter: filter
    };
};

var requestLevels = exports.requestLevels = function requestLevels(filter) {
    return {
        type: REQUEST_LEVELS,
        filter: filter
    };
};

var receiveLevels = exports.receiveLevels = function receiveLevels(filter, json) {
    return {
        type: RECEIVE_LEVELS,
        filter: filter,
        levels: json,
        received_at: Date.now()
    };
};
var failureLevels = exports.failureLevels = function failureLevels(error) {
    return {
        type: FAILURE_LEVELS,
        error: error
    };
};

var shouldFetchLevels = function shouldFetchLevels(state, filter) {
    var levels = state.level.levels;
    if (levels.items.length === 0) {
        return true;
    }
    if (levels.isFetching) {
        return false;
    }
    // return levels.didInvalidate
    return true;
};

var fetchLevelsIfNeeded = exports.fetchLevelsIfNeeded = function fetchLevelsIfNeeded(filter) {
    return function (dispatch, getState) {
        if (shouldFetchLevels(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestLevels(filter));
                return (0, _api.fetchLevels)(filter).then(function (response) {

                    if (!response.ok) {
                        return Promise.reject(response);
                    }
                    return response.json();
                }).then(function (json) {
                    return dispatch(receiveLevels(filter, json));
                }).catch(function (error) {
                    return dispatch(failureLevels(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/level.js
// module id = 884
// module chunks = 0